export const NoteTemplateIcon = () => {
  return (
    <svg
      width="30px"
      height="30px"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M20.841 2.65519C19.9623 1.77651 18.5377 1.77652 17.659 2.6552L13.5 6.8142V6.25402C13.5 5.01138 12.4926 4.00402 11.25 4.00402H4.25C3.00736 4.00402 2 5.01138 2 6.25402V24.2541C2 25.2206 2.7835 26.0041 3.75 26.0041H21.75C22.9926 26.0041 24 24.9967 24 23.7541V16.75C24 15.5074 22.9926 14.5 21.75 14.5H21.1941L25.349 10.3452C26.2277 9.46648 26.2277 8.04186 25.349 7.16318L20.841 2.65519ZM13.5 10.6941L17.3059 14.5H13.5V10.6941ZM12 14.5H3.5V6.25402C3.5 5.83981 3.83579 5.50402 4.25 5.50402H11.25C11.6642 5.50402 12 5.83981 12 6.25402V14.5ZM3.5 16H12V24.504H4.25C3.83579 24.504 3.5 24.1682 3.5 23.754L3.5 16ZM13.5 24.5041V16H21.75C22.1642 16 22.5 16.3358 22.5 16.75V23.7541C22.5 24.1683 22.1642 24.5041 21.75 24.5041H13.5Z"
          fill="#018749"
        ></path>
      </g>
    </svg>
  );
};
